import { flow, pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import {
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  fetchApi,
  setBodyFormData,
} from '../..';
import { createAuthorizedPostMultipartRequest, createAuthorizedPutMultipartRequest } from '@/services/api/request/factories';

const baseUrl = '/v2/checklist-word-templates';
const recordUrl = (id: number) => `${baseUrl}/${id}`;
const byChecklistUrl = (checklistId: number) => `/v2/checklists/${checklistId}/word-template`;

export const upload = (file: File) => {
  const formData = new FormData();
  formData.append('file', file, file.name);

  return pipe(
    baseUrl,
    createAuthorizedPostMultipartRequest,
    map(setBodyFormData(formData)),
    chain(fetchApi),
  );
};

export const update = (id: number, file: File) => {
  const formData = new FormData();
  formData.append('file', file, file.name);

  return pipe(
    id,
    recordUrl,
    createAuthorizedPutMultipartRequest,
    map(setBodyFormData(formData)),
    chain(fetchApi),
  );
};

export const remove = flow(
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const getByChecklist = flow(
  byChecklistUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
);
